import React, { Component } from "react";

class ScrollspyNav extends Component {
  constructor(props) {
    super(props);

    this.scrollTargetIds = props.scrollTargetIds || [];
    this.activeNavClass = props.activeNavClass || "active";
    this.scrollDuration = Number(props.scrollDuration) || 1000;
    this.headerBackground = props.headerBackground === "true";

    if (props.router === "HashRouter") {
      this.homeDefaultLink = "#/";
      this.hashIdentifier = "#/#";
    } else {
      this.homeDefaultLink = "/";
      this.hashIdentifier = "#";
    }
  }

  easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  scrollTo(start, to, duration) {
    const change = to - start;
    let currentTime = 0;
    const increment = 10;

    const animateScroll = () => {
      currentTime += increment;
      const val = this.easeInOutQuad(currentTime, start, change, duration);
      window.scrollTo(0, val);
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  }

  getNavLinkElement(id) {
    return document.querySelector(`a[href='${this.hashIdentifier}${id}']`);
  }

  getNavToSectionID(href) {
    return href.includes(this.hashIdentifier)
      ? href.replace(this.hashIdentifier, "")
      : "";
  }

  componentDidMount() {
    const navList = document.querySelector("div[data-nav='list']");
    if (!navList) return;

    // Scroll to top on home link click
    const homeLink = document.querySelector(`a[href='${this.homeDefaultLink}']`);
    if (homeLink) {
      homeLink.addEventListener("click", (e) => {
        e.preventDefault();
        this.scrollTo(window.pageYOffset, 0, this.scrollDuration);
        window.location.hash = "";
      });
    }

    // Attach smooth scroll to nav link clicks
    navList.querySelectorAll("a").forEach((navLink) => {
      navLink.addEventListener("click", (e) => {
        e.preventDefault();
        const sectionID = this.getNavToSectionID(navLink.getAttribute("href"));
        const target = document.getElementById(sectionID);
        if (target) {
          this.scrollTo(window.pageYOffset, target.offsetTop, this.scrollDuration);
        }
      });
    });

    // Scroll event for active class switching
    window.addEventListener("scroll", () => {
      this.scrollTargetIds.forEach((sectionID, index) => {
        const sectionEl = document.getElementById(sectionID);
        const navLink = this.getNavLinkElement(sectionID);
        if (!sectionEl || !navLink) return;

        const offsetTop =
          sectionEl.offsetTop -
          (this.headerBackground
            ? document.querySelector("div[data-nav='list']")?.scrollHeight || 0
            : 0);

        const inView =
          window.pageYOffset >= offsetTop &&
          window.pageYOffset < offsetTop + sectionEl.scrollHeight;

        const atBottom =
          index === this.scrollTargetIds.length - 1 &&
          window.innerHeight + window.pageYOffset >= document.body.scrollHeight;

        if (inView || atBottom) {
          navLink.classList.add(this.activeNavClass);
          navLink.parentNode?.classList.add(this.activeNavClass);
          this.clearOtherNavLinkActiveStyle(sectionID);
        } else {
          navLink.classList.remove(this.activeNavClass);
          navLink.parentNode?.classList.remove(this.activeNavClass);
        }
      });
    });
  }

  clearOtherNavLinkActiveStyle(activeID) {
    this.scrollTargetIds.forEach((id) => {
      if (id === activeID) return;
      const navLink = this.getNavLinkElement(id);
      if (navLink) {
        navLink.classList.remove(this.activeNavClass);
        navLink.parentNode?.classList.remove(this.activeNavClass);
      }
    });
  }

  render() {
    return (
      <div data-nav="list" className={this.props.className}>
        {this.props.children}
      </div>
    );
  }
}

export default ScrollspyNav;




// import React, { Component } from "react";

// class ScrollspyNav extends Component {
//   constructor(props) {
//     super(props);

//     this.props = props;
//     this.scrollTargetIds = this.props.scrollTargetIds;
//     this.activeNavClass = this.props.activeNavClass;
//     this.scrollDuration = Number(this.props.scrollDuration) || 1000;
//     this.headerBackground =
//       this.props.headerBackground === "true" ? true : false;

//     if (this.props.router && this.props.router === "HashRouter") {
//       this.homeDefaultLink = "#/";
//       this.hashIdentifier = "#/#";
//     } else {
//       this.homeDefaultLink = "/";
//       this.hashIdentifier = "#";
//     }
//   }

//   easeInOutQuad(current_time, start, change, duration) {
//     current_time /= duration / 2;
//     if (current_time < 1)
//       return (change / 2) * current_time * current_time + start;
//     current_time--;
//     return (-change / 2) * (current_time * (current_time - 2) - 1) + start;
//   }

//   scrollTo(start, to, duration) {
//     let change = to - start,
//       currentTime = 0,
//       increment = 10;

//     let animateScroll = () => {
//       currentTime += increment;
//       let val = this.easeInOutQuad(currentTime, start, change, duration);
//       window.scrollTo(0, val);
//       if (currentTime < duration) {
//         setTimeout(animateScroll, increment);
//       }
//     };

//     animateScroll();
//   }

//   getNavLinkElement(sectionID) {
//     return document.querySelector(
//       `a[href='${this.hashIdentifier}${sectionID}']`
//     );
//   }

//   getNavToSectionID(navHref) {
//     return navHref.includes(this.hashIdentifier)
//       ? navHref.replace(this.hashIdentifier, "")
//       : "";
//   }

//   componentDidMount() {
//     if (document.querySelector(`a[href='${this.homeDefaultLink}']`)) {
//       document
//         .querySelector(`a[href='${this.homeDefaultLink}']`)
//         .addEventListener("click", (event) => {
//           event.preventDefault();
//           this.scrollTo(window.pageYOffset, 0, this.scrollDuration);
//           window.location.hash = "";
//         });
//     }

//     document
//       .querySelector("div[data-nav='list']")
//       .querySelectorAll("a")
//       .forEach((navLink) => {
//         navLink.addEventListener("click", (event) => {
//           event.preventDefault();
//           let sectionID = this.getNavToSectionID(navLink.getAttribute("href"));

//           if (sectionID) {
//             let scrollTargetPosition = document.getElementById(sectionID).offsetTop;

//             // let scrollTargetPosition =
//             //   document.getElementById(sectionID).offsetTop -
//             //   (this.headerBackground
//             //     ? document.querySelector("div[data-nav='list']").scrollHeight
//             //     : 0);
//             this.scrollTo(
//               window.pageYOffset,
//               scrollTargetPosition,
//               this.scrollDuration
//             );
//           } else {
//             this.scrollTo(window.pageYOffset, 0, this.scrollDuration);
//           }
//         });
//       });

//       window.addEventListener("scroll", () => {
//         this.scrollTargetIds.forEach((sectionID, index) => {
//           let scrollSectionOffsetTop =
//             document.getElementById(sectionID).offsetTop -
//             (this.headerBackground
//               ? document.querySelector("div[data-nav='list']").scrollHeight
//               : 0);
      
//           if (
//             window.pageYOffset >= scrollSectionOffsetTop &&
//             window.pageYOffset <
//               scrollSectionOffsetTop +
//                 document.getElementById(sectionID).scrollHeight
//           ) {
//             this.getNavLinkElement(sectionID).classList.add(this.activeNavClass);
//             this.getNavLinkElement(sectionID).parentNode.classList.add(
//               this.activeNavClass
//             );
//             this.clearOtherNavLinkActiveStyle(sectionID);
//           } else {
//             this.getNavLinkElement(sectionID).classList.remove(
//               this.activeNavClass
//             );
//             this.getNavLinkElement(sectionID).parentNode.classList.remove(
//               this.activeNavClass
//             );
//           }
      
//           if (
//             index === this.scrollTargetIds.length - 1 &&
//             window.innerHeight + window.pageYOffset >= document.body.scrollHeight
//           ) {
//             this.getNavLinkElement(sectionID).classList.add(this.activeNavClass);
//             this.getNavLinkElement(sectionID).parentNode.classList.add(
//               this.activeNavClass
//             );
//             this.clearOtherNavLinkActiveStyle(sectionID);
//           }
//         });
//       });
      
//   }

//   // clearOtherNavLinkActiveStyle(excludeSectionID) {
//   //   this.scrollTargetIds.map((sectionID) => {
//   //     if (sectionID !== excludeSectionID) {
//   //       this.getNavLinkElement(sectionID).classList.remove(this.activeNavClass);
//   //       this.getNavLinkElement(sectionID).parentNode.classList.remove(
//   //         this.activeNavClass
//   //       );
//   //     }
//   //   });
//   // }

//   clearOtherNavLinkActiveStyle(excludeSectionID) {
//     this.scrollTargetIds.filter(sectionID => sectionID !== excludeSectionID).forEach(sectionID => {
//       this.getNavLinkElement(sectionID).classList.remove(this.activeNavClass);
//       this.getNavLinkElement(sectionID).parentNode.classList.remove(
//         this.activeNavClass
//       );
//     });
// }

//   render() {
//     return (
//       <div data-nav="list" className={this.props.className}>
//         {this.props.children}
//       </div>
//     );
//   }
// }

// export default ScrollspyNav;
